export default "__VITE_ASSET__CfgVmQsY__"